import { render, staticRenderFns } from "./RegionManagement.vue?vue&type=template&id=7a591238&scoped=true"
import script from "./RegionManagement.vue?vue&type=script&lang=js"
export * from "./RegionManagement.vue?vue&type=script&lang=js"
import style0 from "./RegionManagement.vue?vue&type=style&index=0&id=7a591238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a591238",
  null
  
)

export default component.exports